import React, { Component } from 'react';
import DownArrow from '../common/DownArror';
import { Link as ScrollLink } from 'react-scroll';
import LazyLoad from 'react-lazyload';
import Twitter from '../icons/Twitter';
import Github from '../icons/Github';
import Linkedin from '../icons/Linkedin';
import Mail from '../icons/Mail';
import ContactForm from '../contact/ContactForm';
import Location from '../icons/Location';

export class Welcome extends Component {
	state = {
		modalOpen: false
	};
	toggleModal = (e) => {
		e.stopPropagation();
		this.setState((prevState) => ({ modalOpen: !prevState.modalOpen }));
	};
	render() {
		return (
			<div id="welcome" className="container">
				<LazyLoad height="10">
					<ContactForm show={this.state.modalOpen} handleClose={this.toggleModal} />
				</LazyLoad>
				<div className={`welcome__container grid text-center`}>
					<div className="welcome__text">
						<h1 className="spacing-03">Baris Ozcetin</h1>
						<h2>Software Engineer</h2>

						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
							<Location /> <h3>Seattle</h3>
						</div>
						{/* <h3>Located in Seattle</h3> */}
						<hr className="welcome__seperator" />
						<div className="social__links">
							<a href="https://github.com/barisozcetin/" className="social__link" aria-label="github">
								{/* <i className="fab fa-github fa-2x" /> */}
								{/* <i className="icon-github-circled" /> */}
								<i>
									<Github />
								</i>
							</a>
							<a href="https://www.linkedin.com/in/baris-ozcetin/" className="social__link" aria-label="linkedin">
								{/* <i className="fab fa-linkedin-in fa-2x" /> */}
								{/* <Webpage /> */}
								<i>
									<Linkedin />
								</i>
							</a>
							<a href="https://www.twitter.com/baris_ozcetin" className="social__link" aria-label="twitter">
								{/* <i className="fab fa-twitter fa-2x" /> */}
								<i>
									<Twitter />
								</i>
							</a>
							<button
								tabIndex="0"
								className="social__link"
								aria-label="contact"
								style={{ background: 'none' }}
								onClick={this.toggleModal}
								id="btn-modal"
							>
								<i>
									<Mail />
								</i>
							</button>
						</div>
					</div>
					<div className="welcome__second">
						<ScrollLink className="to-bottom welcome__bottom" to="about" smooth={true} duration={500}>
							<DownArrow />
						</ScrollLink>
					</div>
				</div>
			</div>
		);
	}
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/containers/Welcome.js